// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__Yxb9X","primary":"Box_primary__dWyq3","warning":"Box_warning__BQo_2","sm":"Box_sm__r_RSm","base":"Box_base__lO3MB","withBorder":"Box_withBorder__lDNCa"};